import React from 'react';
import { AuthLayout } from '../../../components/layout/Layouts'; 
import HrDashboardIndex from '../../../components/Dashboard/HrDashboardIndex'; 

const HrDashboardPage = () => {
  return (
    <AuthLayout>
      <HrDashboardIndex />
    </AuthLayout>
  );
};

export default HrDashboardPage;
